import React from 'react';
import Image from 'next/image';
import s from './CompanyQuote.module.scss';
import { FluidImage } from '../ContentfulImage';

interface CompanyQuoteProps {
  companyQuote: {
    title?: string | null;
    quote?: string | null;
    icons?: {
      width?: number;
      height?: number;
      fluid: FluidImage | null;
    }[] | null;
  };
}

const CompanyQuote: React.FC<CompanyQuoteProps> = ({ companyQuote }) => {
  return (
    <div className={s.layeredComponent} data-testid="companyQuote">
      <div className={s.bottomLayer}>
        <div className={s.darkBackground} />
      </div>
      <div className={s.topLayer}>
        <div className={s.copyContainer}>
          <div className={s.awsLogos}>
            <h3 className={s.quote} data-testid="cqTitle">
              {companyQuote?.title}
            </h3>
            <p className={s.quote} data-testid="cqQuote">
              {companyQuote?.quote}
            </p>
            <div className={s.quote}>
              {companyQuote.icons &&
                companyQuote.icons.length > 0 &&
                companyQuote.icons.map((icon) => (
                  icon.fluid && (
                    <div key={icon.fluid.src} data-testid="cqIcons">
                      <Image
                        src={icon.fluid.src}
                        height={icon.height}
                        width={icon.width}
                        className={s.emoji}
                        alt="Company Quote"
                      />
                    </div>
                  )
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompanyQuote;
